<template>
  <div class="yum-drawer-layout">
    <!--抽屉-->
    <div class="yum-drawer-wrap" :style="drawerW()" v-if="showdraw">
      <slot name="drawer"></slot>
    </div>
    <!--主容器-->
    <div class="yum-content-wrap" :style="contentClass(visible)" ref="yumContent" >
      <!--遮罩-->
      <div class="yum-drawer-mask" v-show="visible">

      </div>
      <slot name="content">
      </slot>
    </div>
  </div>
</template>
<script>


  export default {
    name: 'yum_drawer_layout',
    data () {
      return {
        drawerWrap: false,
        visible: false,
        showdraw: false,
        time: ''
      }
    },
    watch: {
      visible (value) {
        if (value) {
          this.showdraw = value
        } else {
          window.clearTimeout(this.time)
          this.time = setTimeout((value) => {
            this.showdraw = false
          }, 500)
        }
      }
    },
    methods: {
      drawerW () {
        return 'width:' + this.drawerWidth + 'px'
      },

      // 开关
      toggle (visible,callback) {
        this.visible = visible;
        if(callback){
          callback(this.visible)
        }
      },
      contentClass (visible) {
        if (visible) {
          return {
            transform: 'translate3d( ' + this.drawerWidth + 'px , 0, 0)',
            transition: '0.3s'
          }
        } else {
          return {
            transform: 'translate3d( 0 , 0, 0)',
            transition: '0.3s'
          }
        }
      }
    },
    props: {
      drawerWidth: {
        type: Number,
        default:0
      },

      MaskTouch:{
        type:Function,
        default: null
      },

    }
  }
</script>

<style scoped lang="scss">
  .yum-drawer-layout{
    position: absolute;
    bottom: 0;
    top: 62px;
    width: 100%;
  }
  .yum-content-wrap{
    height: 100%;

  }
  .yum-drawer-mask{
    position: fixed;
    top:0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color:rgba(0,0,0,0.3);
    z-index: 9999;
    pointer-events:none;
    display: block;
  }
  .yum-drawer-wrap{
    background-color: white;
    text-align: left;
    position: fixed;
    left: 0;
    top:0;
    bottom: 0;
  }

  @keyframes slideInLeft {
    from {
      -webkit-transform: translate3d(-100%, 0, 0);
      transform: translate3d(-100%, 0, 0);
      visibility: visible;
    }

    to {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
  }
  .slideInLeft {
    /*animation: slideInLeft 2s;*/
  }
  .slideInLeftname {
    -webkit-animation-name: slideInLeft;
    animation-name: slideInLeft;
  }
  /*slide*/
  .openleft-enter-active,.openleft-leave-active{
    transition: all 2s;
  }

  .openleft-enter{
    transform: translateX(10%);
  }
  .openleft-leave-to{
    transform: translateX(-100%);
  }

</style>



// WEBPACK FOOTER //
// src/components/yum_drawer_layout/yum_drawer_layout.vue